export default {
  dark: {
    icon: 'moon',
    sound: 'https://www.joshwcomeau.com/sounds/switch-on.mp3',
    background: {
      primary: '#161f23',
      secondary: '#1e2931',
    },
    decorator: {
      primary: '#2c0e7b',
      secondary: '#194c7c',
      contrast: '#FFF',
    },
    text: {
      primary: '#FFF',
      secondary: '#FFF',
    },
  },
  light: {
    icon: 'sun',
    sound: 'https://www.joshwcomeau.com/sounds/switch-off.mp3',
    background: {
      primary: '#eef4f4',
      secondary: '#d7dee7',
    },
    decorator: {
      primary: '#5b8cbd',
      secondary: '#d29b3b',
      contrast: '#222',
    },
    text: {
      primary: '#222',
      secondary: '#222',
    },
  },
}
